<template>
  <div class="border-0">
    <h2>
      My Aggregated Reports
      <span @click="setvisible">
        <fa-icon
          :name="visible ? 'chevron-up' : 'chevron-down'"
          class="mx-2"
          aria-controls="myaggregatedreportscollapse"
        />
      </span>
    </h2>
    <b-collapse
      id="myaggregatedreportscollapse"
      v-model="visible"
      class="mt-2"
    >
      <b-card class="border-0 my-0 py-0">
        <b-table
          striped
          responsive
          hover
          primary-key="id"
          :items="reports"
          :fields="fields"
          @row-clicked="report_download"
          @sort-changed="data_sort"
        >
          <template v-slot:cell(report_name)="data">
            <span :class="`${anon ? 'g-anon' : '' }`">{{ data.item.report_name }}</span>
          </template>
          <template v-slot:cell(download)>
            <span
              class="justify-content-right align-right"
            >
              <fa-icon
                class="text-primary mr-4"
                name="file-download"
              />
            </span>
          </template>
          <template v-slot:cell(action)="data">
            <span
              class="justify-content-right align-right"
              @click.prevent.stop="record_delete_confirm(data.item.id)"
            >
              <fa-icon
                class="text-primary"
                name="trash-alt"
                @click.prevent.stop="report_delete(data.item.id)"
              />
            </span>
          </template>
        </b-table>
        <b-row class="col-12 justify-content-center">
          <b-pagination
            v-if="rows>perPage"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="reports"
            @input="reports_get"
          />
        </b-row>
      </b-card>
    </b-collapse>
    <b-modal
      v-model="deleteshow"
      hide-footer
      title="Delete record?"
    >
      Do you really want to delete this report?
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="record_delete"
      >
        Yes, delete
      </b-button>
      <b-button
        class="mt-2"
        variant="secondary"
        block
        @click="record_delete_cancel"
      >
        Cancel
      </b-button>
    </b-modal>
  </div>
</template>
<script>

const fields = [
  { key: 'id', label: 'ID', sortable: true },
  { key: 'report_name', label: 'Report name', sortable: true },
  { key: 'report_date', label: 'Date', sortable: true },
  { key: 'survey_type', label: 'Survey type', sortable: true },
  { key: 'download', tdClass: 'w-5', label: '', sortable: false },
  { key: 'action', tdClass: 'w-5', label: '', sortable: false }
]
export default {
  name: 'MyAggregatedReports',
  data: function () {
    return {
      reports: [],
      fields: fields,
      visible: this.$store.state.mypage_reports_open,
      deleteshow: false,
      currentPage: 1,
      perPage: 10,
      rows: 0,
      orderby: 'report_date',
      orderdesc: true
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    }
  },
  created () {
    this.reports_get()
  },
  methods: {
    data_sort (context) {
      this.orderby = context.sortBy
      this.orderdesc = context.sortDesc
      this.currentPage = 1
      this.reports_get()
    },
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setagreportsopen', this.visible)
    },
    record_delete_confirm (id) {
      this.deleting = id
      this.deleteshow = true
    },
    record_delete () {
      this.$store.dispatch('record_delete', {
        table_name: 'g_agreports',
        id: this.deleting
      })
        .then(() => {
          this.deleting = 0
          this.deleteshow = false
          this.reports_get()
        })
    },
    record_delete_cancel () {
      this.deleting = 0
      this.deleteshow = false
    },
    reports_get: function () {
      this.loading = true
      this.$store
        .dispatch('aggregatedreports_get', {
          user_id: this.$store.state.user_id,
          start: (this.currentPage - 1) * this.perPage,
          limit: this.perPage,
          orderby: this.orderby,
          order: (this.orderdesc ? 'DESC' : 'ASC')
        })
        .then(result => {
          let reports = result.data.result
          this.rows = result.data.total
          this.reports = reports
        })
    },
    report_download (item, index, event) {
      this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: item.id })
        .then(() => {
          this.$router.push('/aggregatedreports')
        })
    }
  }
}
</script>
<style scoped></style>
